export const formatPrice = (price: number): string => {
    return price.toFixed(2).endsWith(".00") ? price.toFixed() : price.toFixed(2);
};
